import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComplexPlane = _resolveComponent("ComplexPlane")!

  return (_openBlock(), _createBlock(_component_ComplexPlane, {
    ref: "complexPlane",
    update: [_ctx.c, _ctx.colorScheme, _ctx.shouldUpdate, _ctx.axes],
    onResize: _ctx.onResize,
    onContext: _ctx.initGL,
    onRender: _ctx.onRender,
    onViewChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewChanged = true))
  }, null, 8, ["update", "onResize", "onContext", "onRender"]))
}